import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as WondeSyncActions from './wonde-sync.actions';
import {
  selectWondeSyncActionInProgressId,
  selectWondeSyncError,
  selectWondeSyncLoading,
  selectWondeSyncMismatches,
  selectWondeSyncPendingCount,
  selectWondeSyncSkippedError,
  selectWondeSyncSkippedMismatches
} from './wonde-sync.selectors';
import { AppState } from '../app.reducer';
import { WondeSyncMismatch } from '@core/models/domain/wonde-sync.domain';

@Injectable({ providedIn: 'root' })
export class WondeSyncStoreFacade {
  mismatches$: Observable<WondeSyncMismatch[]> = this.store.select(selectWondeSyncMismatches);
  skippedMismatches$: Observable<WondeSyncMismatch[]> = this.store.select(selectWondeSyncSkippedMismatches);
  skippedError$: Observable<string | null> = this.store.select(selectWondeSyncSkippedError);
  loading$: Observable<boolean> = this.store.select(selectWondeSyncLoading);
  error$: Observable<string | null> = this.store.select(selectWondeSyncError);
  actionInProgressId$: Observable<string | null> = this.store.select(selectWondeSyncActionInProgressId);
  pendingCount$: Observable<number> = this.store.select(selectWondeSyncPendingCount);

  constructor(private store: Store<AppState>) {}

  loadMismatches(): void {
    this.store.dispatch(WondeSyncActions.loadMismatches());
  }

  loadSkippedMismatches(): void {
    this.store.dispatch(WondeSyncActions.loadSkippedMismatches());
  }

  /**
   * applyWondeData true takes the MIS identity except the keepSchoolFields the admin chose to
   * keep; false keeps what the school recorded.
   */
  link(mismatchId: string, selectedPupilAccountId: string, applyWondeData: boolean, keepSchoolFields: string[] = []): void {
    this.store.dispatch(WondeSyncActions.linkMismatch({
      request: { mismatchId, selectedPupilAccountId, applyWondeData, keepSchoolFields }
    }));
  }

  createPupil(mismatchId: string): void {
    this.store.dispatch(WondeSyncActions.createPupil({ mismatchId }));
  }

  dismiss(mismatchId: string, note?: string | null): void {
    this.store.dispatch(WondeSyncActions.dismissMismatch({ mismatchId, note }));
  }

  assignGroups(mismatchId: string, schoolGroupIds: string[]): void {
    this.store.dispatch(WondeSyncActions.assignGroups({ request: { mismatchId, schoolGroupIds } }));
  }
}
